module.exports = __webpack_public_path__ + "img/collectiongallery_naturalbeige.9cb3f08.webp";